import { put, select } from "redux-saga/effects";
import { BatchFetchCfarOfferResponseV2, Passengers } from "redmond";
import { IBatchFetchCfarOffers } from "../../actions/actions";
import { actions } from "../../actions";
import { getBatchCfarOffers } from "../../../../api/v2/ancillary/getBatchCfarOffers";
import Logger from "../../../../helpers/Logger";
import { passengerCountSelector } from "../../../search/reducer/selectors";

export function* batchFetchCfarOffersSaga(action: IBatchFetchCfarOffers) {
  try {
    const { requests, variant } = action;
    const passengers: Passengers = yield select(passengerCountSelector);
    const response: BatchFetchCfarOfferResponseV2 = yield getBatchCfarOffers({
      requests,
      passengers,
    });

    yield put(actions.setCfarOffers(response.responseByTripId, variant));
  } catch (e) {
    yield put(actions.setBatchCfarOffersCallStateFailed());
    Logger.debug(e);
  }
}
